import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setVolunteerRequest } from '../../actions/volunteerActions';
import ItemSubTitle from './ItemSubTitle';
import ItemTitle from './ItemTitle';
import ItemSmallLogo from './ItemSmallLogo';
import Stats from './Stats';

class VolunteerListItem extends React.Component {

    constructor(props){
        super(props);
        this.selectRequest = this.selectRequest.bind(this);

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    selectRequest(){
        let request = this.props.hit;
        // request.selectedRequest = this.props.hit;
        this.props.setVolunteerRequest(request);
    }
    render(){

        console.log(this.props.hit)
        return (
            <div className="VolunteerListItem" onClick={this.selectRequest}>
                <div>
                    <ItemSmallLogo src={ this.props.hit.image } />
                </div>
                <div style={{flex:1}}>
                    <ItemTitle style={{marginBottom:5}} content={this.props.hit.selectedRequest.title} />
                    <ItemSubTitle truncate={400} content={this.props.hit.selectedRequest.description} />  
                </div>
                <div>
                    <Stats quantity={this.props.hit.selectedRequest.quantity} distance={this.props.hit._rankingInfo.geoDistance} />
                </div>
                
                <style jsx>{`
                    .VolunteerListItem {
                        border-radius: .28571429rem;
                        background: #fff;
                        -webkit-box-shadow: 0 1px 2px 0 rgba(34,36,38,.15), 0 0 0 1px rgba(34,36,38,.15);
                        box-shadow: 0 1px 2px 0 rgba(34,36,38,.15), 0 0 0 1px rgba(34,36,38,.15);
                        display:flex;
                        padding:10px;
                        align-items: center;
                        cursor: pointer;
                    }
                `}</style>
               
            </div>
        )
    }
}

VolunteerListItem.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, { setVolunteerRequest })(VolunteerListItem);



// WEBPACK FOOTER //
// ./src/components/common/VolunteerListItem.js